import { c as _c } from "react/compiler-runtime";
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { ReactElement } from 'react';
import { SearchBarProvider } from '@core/journeys/ui/algolia/SearchBarProvider';
import { ResourceHeading } from '@core/journeys/ui/ResourceHeading';
import { SearchBar } from '@core/journeys/ui/SearchBar';
import { PageWrapper } from '../PageWrapper';
import { ResourceSections } from './ResourceSections';
export function ResourcesView() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      px: {
        xs: 0
      },
      py: {
        xs: 6,
        sm: 9
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      p: 0,
      gap: 10
    };
    t2 = <ResourceHeading heading="Resources" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PageWrapper hideHeaderTabButtons={true}><Container maxWidth="xxl" sx={t0}><Stack sx={t1}>{t2}<SearchBarProvider><SearchBar /></SearchBarProvider><ResourceSections includeIndex={true} /></Stack></Container></PageWrapper>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}